class BaseMap {
    constructor(el, options) { }
    addListener(eventName, handler) { }
    clearListeners(eventName) {}
    getCenter() { }
    setCenter(location) { }
    getBounds() { }
    fitBounds(viewPort) { }
    getZoom() { }
    setZoom(zoom) { }
    createMarker(markerOptions) { }
    createCircle(marker, circleOptions) { }
    getViewPort() { }
}

class LatLng {
    constructor(lat, lng) {
        this._lat = lat;
        this._lng = lng;
    }
}

class BaseMarker {
    constructor(map, options) { }

    setMap(map) { }

    getPosition() { }

    setPosition(location) { }

    addListener(eventName, handler) { }

    setAnimation(animation) { }

    resetMap() { }
}

class BaseCircle {
    constructor(map, marker, options) { }

    bindTo(center, position) { }

    setRadius(circleRadius) { }

    getBounds() { }
}


export {BaseMap, LatLng, BaseMarker, BaseCircle};
